export enum UserAvatarSource {
  None = 0,
  Gravatar = 10,
}
